import axios, { CancelTokenSource } from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const GetSchedulerGant = (cond: string) => {
  var query = GetBackendUrlForGlobalFunctions() + `order?where=` + cond;
  return axios.get(query, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
  });
};

export const GetSchedulerKPI = (cond: string) => {
  var query = GetBackendUrlForGlobalFunctions() + `gant/kpi?where=` + cond;
  return axios.get(query);
};
export const GetGanttSettings = (cond: string) => {
  var query = GetBackendUrlForGlobalFunctions() + `gant/settings?where=` + cond;
  return axios.get(query);
};
export const EditGanttSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `gant/settings/update`,
    obj,
    {
      headers,
    }
  );
};
export const GetSchedulerLoad = (cond: string) => {
  var query =
    GetBackendUrlForGlobalFunctions() + `gant/load-and-capacity?where=` + cond;
  return fetch(query, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
  });
};
export const GetPlanOrderGant = (
  cond: string,
  tokenSource?: CancelTokenSource
) => {
  var query = GetBackendUrlForGlobalFunctions() + `gant?where=` + cond;
  return axios.get(query, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
    cancelToken: tokenSource?.token,
  });
};
export const GetKanbanColor = (cond: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `priority?where=` + cond
  );
};
export const GetKanBanGraph = (cond: string) => {
  var query =
    GetBackendUrlForGlobalFunctions() + `kanban/graphdata?where=` + cond;
  return axios.get(query);
};
export const GetOrderDetail = (cond: string) => {
  var query =
    GetBackendUrlForGlobalFunctions() + `kanban/countOfStatus?where=` + cond;
  return axios.get(query);
};

export const EditWorkOrder = (obj: Object, timezoneOffset?: number) => {
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  if (ERP_TYPE === 'PRONTO') {
    timezoneOffset = 0;
  }
  const headers = {
    'Content-Type': 'application/json',
  };
  //      let theUrl = GetBackendUrlForGlobalFunctions() + `${edit_query}`+`/${timezoneOffset}`;

  return axios.put(
    GetBackendUrlForGlobalFunctions() + `order/edit` + `/${timezoneOffset}`,
    obj,
    {
      headers,
    }
  );
};
export const GetMaxProntoRowIdData = () => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `mex-order/max-pronto-row-id`
  );
};

export const EditKanbanColor = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `priority/edit`, obj, {
    headers,
  });
};
export const DeleteKanbanColor = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `priority/delete`, obj, {
    headers,
  });
};
